export default __webpack_public_path__ + "static/media/home-inactive.1bc3e951.svg";